import { r4Client, r4Error } from '@/services'

const DatasourceApi = {

  async getCsvFinalDocumentUrl (csvDatasource) {
    try {
      const resp = await r4Client().post(`/api/v1/csv_datasources/${csvDatasource.id}/final_document_url`, {})
      return resp.data.data.url
    } catch (error) {
      throw r4Error(error)
    }
  },
  async getCsvOriginalDocumentUrl (csvDatasource) {
    try {
      const resp = await r4Client().post(`/api/v1/csv_datasources/${csvDatasource.id}/original_document_url`, {})
      return resp.data.data.url
    } catch (error) {
      throw r4Error(error)
    }
  },
  async getCsvAdditionalDocumentUrl (csvDatasource, docId) {
    try {
      const resp = await r4Client().post(`/api/v1/csv_datasources/${csvDatasource.id}/additional_document_url`, { doc_id: docId })
      return resp.data.data.url
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default DatasourceApi
